const header = "_35shw7ggvq";
const fragment = "_35sf1kx0ip4";
const date = "_35sd5xms92";

export { date, fragment, header };
import "./molecule.tasks-header.style.linaria.module.css";
//# sourceMappingURL=molecule.tasks-header.style.js.map
